module.exports = __webpack_public_path__ + "static/img/19.194d6ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/19.png
// module id = X4xz
// module chunks = 0